module.exports = __webpack_public_path__ + "img/chart_pillar.38ccdf2f.svg";